/**
 * Tool & MCP Management Page
 * MCP Servers, Tool Enhancement, Tool Combos, and Performance monitoring
 */

import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import {
  MCPServersPanel,
  ToolEnhancementPanel,
  ToolComboPanel,
  ToolPerformancePanel,
} from '@/features/system-settings';
import { Server, Wrench, Layers, Activity } from 'lucide-react';
import { useI18n } from '@/i18n';

export function ToolManagementPage() {
  const { messages } = useI18n();
  const t = messages.toolManagement;
  const [activeTab, setActiveTab] = useState('mcp');

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t.pageTitle}</h1>
        <p className="text-gray-600 mt-1">
          {t.pageDescription}
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="mcp" className="flex items-center gap-2">
            <Server className="w-4 h-4" />
            {t.tabs.mcpServers}
          </TabsTrigger>
          <TabsTrigger value="tool-enhancement" className="flex items-center gap-2">
            <Wrench className="w-4 h-4" />
            {t.tabs.toolEnhancement}
          </TabsTrigger>
          <TabsTrigger value="tool-combo" className="flex items-center gap-2">
            <Layers className="w-4 h-4" />
            {t.tabs.toolCombo}
          </TabsTrigger>
          <TabsTrigger value="performance" className="flex items-center gap-2">
            <Activity className="w-4 h-4" />
            {t.tabs.performance}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="mcp">
          <MCPServersPanel />
        </TabsContent>

        <TabsContent value="tool-enhancement">
          <ToolEnhancementPanel />
        </TabsContent>

        <TabsContent value="tool-combo">
          <ToolComboPanel />
        </TabsContent>

        <TabsContent value="performance">
          <ToolPerformancePanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
